import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { SharedService } from './services/shared.service';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzResultModule } from 'ng-zorro-antd/result';
import { GlobalLoadingComponent } from './components/global-loading/global-loading.component';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import {NzEmptyComponent, NzEmptyModule} from "ng-zorro-antd/empty";
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NatureOfBusinessSectionComponent } from './components/registration/nature-of-business-section/nature-of-business-section.component';
import { RegisteredOfficeAddressSectionComponent } from './components/registration/registered-office-address-section/registered-office-address-section.component';
import { CorporateStructureSectionComponent } from './components/registration/corporate-structure-section/corporate-structure-section.component';
import { ShareCapitalInformationSectionComponent } from './components/registration/share-capital-information-section/share-capital-information-section.component';
import { FitAndProperSectionComponent } from './components/registration/fit-and-proper-section/fit-and-proper-section.component';
import { AmlSectionComponent } from './components/registration/aml-section/aml-section.component';
import { HeadCompanySectionComponent } from './components/registration/head-company-section/head-company-section.component';
import { HeadOfficeSectionComponent } from './components/registration/head-office-section/head-office-section.component';
import { AmountOfContributionSectionComponent } from './components/registration/amount-of-contribution-section/amount-of-contribution-section.component';
import { IndividualModalComponent } from './components/modals/individual-modal/individual-modal.component';
import { BodyCorporateModalComponent } from './components/modals/body-corporate-modal/body-corporate-modal.component';
import { AttachmentService } from './services/attachment.service';
import { AttachmentPreviewManager } from './managers/attachment-preview.manager';
import { AttachmentPreviewModalComponent } from './components/modals/attachment-preview-modal/attachment-preview-modal.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MlroModalComponent } from './components/modals/mlro-modal/mlro-modal.component';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { PaymentBodyCorporateModalComponent } from './components/modals/payment-body-corporate-modal/payment-body-corporate-modal.component';
import { PaymentIndividualModalComponent } from './components/modals/payment-individual-modal/payment-individual-modal.component';
import { PayerDataModalComponent } from './components/modals/payer-data-modal/payer-data-modal.component';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { AoaSectionComponent } from './components/registration/aoa-section/aoa-section.component';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { RegEntityDocumentPreviewModalComponent } from './components/modals/document-preview-modal/document-preview-modal.component';
import { RejectActionModalComponent } from './components/modals/reject-action-modal/reject-action-modal.component';
import { ReAssignActionModalComponent } from './components/modals/reassign-action-modal/reassign-action-modal.component';
import { ApproveActionModalComponent } from './components/modals/approve-action-modal/approve-action-modal.component';
import { PaymentDetailsDrawerComponent } from './components/payment-details-drawer/payment-details-drawer.component';


@NgModule({
  declarations: [
    GlobalLoadingComponent,
    NatureOfBusinessSectionComponent,
    RegisteredOfficeAddressSectionComponent,
    CorporateStructureSectionComponent,
    ShareCapitalInformationSectionComponent,
    FitAndProperSectionComponent,
    AmlSectionComponent,
    HeadCompanySectionComponent,
    HeadOfficeSectionComponent,
    AmountOfContributionSectionComponent,
    IndividualModalComponent,
    BodyCorporateModalComponent,
    AttachmentPreviewModalComponent,
    MlroModalComponent,
    PaymentBodyCorporateModalComponent,
    PaymentIndividualModalComponent,
    PayerDataModalComponent,
    AoaSectionComponent,
    RegEntityDocumentPreviewModalComponent,
    RejectActionModalComponent,
    ReAssignActionModalComponent,
    ApproveActionModalComponent,
    PaymentDetailsDrawerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,

    // NG-ZORRO modules
    NzLayoutModule,
    NzMenuModule,
    NzInputModule,
    NzIconModule,
    NzCardModule,
    NzButtonModule,
    NzStepsModule,
    NzTabsModule,
    NzCollapseModule,
    NzTagModule,
    NzGridModule,
    NzAvatarModule,
    NzSpinModule,
    NzTableModule,
    NzDescriptionsModule,
    NzModalModule,
    NzDividerModule,
    NzSwitchModule,
    NzSelectModule,
    NzResultModule,
    NzDrawerModule,
    NzEmptyComponent,
    NzPaginationModule,
    NzBadgeModule,
    PdfViewerModule,
    NzCheckboxModule,
    NzEmptyModule,
    NzDropDownModule,
    NzTagModule,
    NzToolTipModule,
    NzIconModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,

    // Exporting NG-ZORRO modules for use in feature modules
    NzLayoutModule,
    NzMenuModule,
    NzInputModule,
    NzIconModule,
    NzCardModule,
    NzButtonModule,
    NzStepsModule,
    NzTabsModule,
    NzCollapseModule,
    NzTagModule,
    NzGridModule,
    NzAvatarModule,
    NzSpinModule,
    NzTableModule,
    NzDescriptionsModule,
    NzModalModule,
    NzDividerModule,
    NzSwitchModule,
    NzSelectModule,
    NzResultModule,
    GlobalLoadingComponent,
    NzDrawerModule,
    NzEmptyComponent,
    NzPaginationModule,
    NzBadgeModule,
    NatureOfBusinessSectionComponent,
    RegisteredOfficeAddressSectionComponent,
    CorporateStructureSectionComponent,
    ShareCapitalInformationSectionComponent,
    FitAndProperSectionComponent,
    AmlSectionComponent,
    HeadCompanySectionComponent,
    HeadOfficeSectionComponent,
    AmountOfContributionSectionComponent,
    IndividualModalComponent,
    BodyCorporateModalComponent,
    AttachmentPreviewModalComponent,
    MlroModalComponent,
    NzCheckboxModule,
    NzEmptyModule,
    PaymentBodyCorporateModalComponent,
    PaymentIndividualModalComponent,
    PayerDataModalComponent,
    NzDropDownModule,
    AoaSectionComponent,
    NzTagModule,
    NzToolTipModule,
    NzIconModule,
    RejectActionModalComponent,
    ReAssignActionModalComponent,
    ApproveActionModalComponent,
    PaymentDetailsDrawerComponent
  ],
  providers: [
    SharedService,
    AttachmentService,
    AttachmentPreviewManager
  ]
})
export class SharedModule {}
